import { render, staticRenderFns } from "./CaseFile.vue?vue&type=template&id=7d20c3aa&scoped=true&"
import script from "./CaseFile.vue?vue&type=script&lang=js&"
export * from "./CaseFile.vue?vue&type=script&lang=js&"
import style0 from "./CaseFile.vue?vue&type=style&index=0&id=7d20c3aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d20c3aa",
  null
  
)

export default component.exports